import React from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { FieldTable2 } from 'components/_basic/Form/FieldTable2';
import { FormSectionFilledCard } from 'components/_basic/FormSectionFilledCard';
import { Loader } from 'components/_basic/Loader/Loader';
import { useTotalExpensesRecalculation } from 'components/BusinessToolForm/Sections/FinancialPlan/hooks/useTotalExpensesRecalculation';
import {
  GLOBAL_PERIOD_NAME,
  GLOBAL_PERIOD_TABLE_HEADINGS_NAME,
} from 'components/BusinessToolForm/Sections/Global/form';

import { getPeriodColumnsNames } from 'helpers/businessTool';
import { concatWithDot } from 'helpers/string';

import { ITotalExpensesFormTableProps } from './types';
import { totalExpensesPrefix } from '../../../utils/form';
import { TOTAL_EXPENSES_FORM_NAMES } from '../../utils/form';

import styles from './TotalExpensesFormTable.module.scss';

const FIRST_COLUMN_WIDTH = 165;

export const TotalExpensesFormTable: React.FC<ITotalExpensesFormTableProps> = ({ disabled }) => {
  const { control } = useFormContext();

  const period = useWatch({ name: GLOBAL_PERIOD_NAME });
  const tableName = concatWithDot(totalExpensesPrefix, TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE);
  const { fields } = useFieldArray({ control, name: tableName });

  const columnsNames = getPeriodColumnsNames(period);

  const variantsName = concatWithDot(totalExpensesPrefix, TOTAL_EXPENSES_FORM_NAMES.EXPENSES_VARIANTS, ':index');
  const tableTotalName = concatWithDot(totalExpensesPrefix, TOTAL_EXPENSES_FORM_NAMES.EXPENSES_TABLE_TOTAL);

  const { recalculateHandler, isPending } = useTotalExpensesRecalculation();

  return (
    <FormSectionFilledCard className={styles.contentWrapper}>
      {isPending && <Loader className={styles.loader} />}
      <FieldTable2
        showSumRow
        rows={fields}
        name={tableName}
        disabled={disabled}
        columnsNames={columnsNames ?? []}
        headerName={GLOBAL_PERIOD_TABLE_HEADINGS_NAME}
        firstColumnWidth={FIRST_COLUMN_WIDTH}
        watchRowTitleName={variantsName}
        totalName={tableTotalName}
        readonlyArrayIndexes={[0, 7]}
        reCalculationHandler={recalculateHandler}
      />
    </FormSectionFilledCard>
  );
};
